import { Box, Grid, Stack, Typography } from '@mui/material';
import get from 'lodash-es/get';
import React from 'react';

import { useConstants } from '../../hooks/useConstants';
import Select from '../forms/Select';
import Switch from '../forms/Switch';
import TextField from '../forms/TextField';
import { SsoIdLink } from '../shared/SsoIdCell';

interface ClientsFormGeneralProps {
  ssoId?: unknown;
}

function ClientsFormGeneral({ ssoId }: ClientsFormGeneralProps) {
  const { constants } = useConstants();

  const ACCEPTED_CHANNELS = Object.entries(get(constants, 'CONTRACT.ACCEPTED_CHANNELS', {})).map(([value, label]) => ({
    value,
    label,
  }));
  const ACCEPTED_REACHES = Object.entries(get(constants, 'CONTRACT.ACCEPTED_REACHES', {})).map(([value, label]) => ({
    value,
    label,
  }));
  const ACCEPTED_SOURCES = Object.entries(get(constants, 'CONTRACT.ACCEPTED_SOURCES', {})).map(([value, label]) => ({
    value,
    label,
  }));

  return (
    <>
      <Grid container mt={2} spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            name="name"
            label="Name"
            fullWidth
            rules={{
              required: 'Please enter a name.',
            }}
            disabled
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack spacing={0.5}>
            <Typography variant="caption" color="text.secondary">
              SSO Id
            </Typography>
            <Typography variant="body1">
              <SsoIdLink kind="organization" ssoId={ssoId} />
            </Typography>
          </Stack>
        </Grid>
      </Grid>
      <Grid container mt={2}>
        <Grid item xs={6}>
          <TextField name="email" label="Email" fullWidth rules={{
              required: 'Please enter your email.',
            }}
            disabled
          />
        </Grid>
      </Grid>
      <Grid container sx={{ width: '66%' }} mt={2} spacing={2}>
        <Grid item xs={12} md={4}>
          <Select
            label="Channel"
            name="channel"
            fullWidth
            options={ACCEPTED_CHANNELS}
            rules={{
              required: 'Please select a channel.',
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Select
            label="Reach"
            name="reach"
            fullWidth
            options={ACCEPTED_REACHES}
            rules={{
              required: 'Please select a reach.',
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Select
            label="Source"
            name="source"
            fullWidth
            options={ACCEPTED_SOURCES}
            rules={{
              required: 'Please select a source.',
            }}
          />
        </Grid>
      </Grid>
      <Box mt={4}>
        <Box>
          <Switch name="sharedAccessForDashboardUsers" label="Shared Access For Dashboard Users" />
        </Box>
        <Box>
          <Switch name="whiteLabeledReports" label="White-Labeled Reports" />
        </Box>
        <Box>
          <Switch name="mapsEnabled" label="Dashboard Maps" />
        </Box>
      </Box>
    </>
  );
}

export default ClientsFormGeneral;
